import React from 'react';
import { PhoneIcon, MailIcon, MessageSquareIcon } from 'lucide-react';
const ContactInfo = () => {
  return <section className="py-16 bg-red-600 text-white relative" data-id="element-24">
      <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1452421822248-d4c2b47f0c81?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80")'
    }} data-id="element-25"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-26">
        <div className="text-center mb-12" data-id="element-27">
          <h2 className="text-3xl font-bold mb-4" data-id="element-28">Contact Us</h2>
          <p className="max-w-2xl mx-auto" data-id="element-29">
            Have questions about our packages or need help planning your trip?
            Reach out to us anytime!
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto" data-id="element-30">
          <div className="bg-white bg-opacity-10 p-8 rounded-lg text-center" data-id="element-31">
            <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-32">
              <PhoneIcon size={24} className="text-red-600" data-id="element-33" />
            </div>
            <h3 className="text-xl font-semibold mb-2" data-id="element-34">Call Us</h3>
            <p className="mb-2" data-id="element-35">Available 24/7 for assistance</p>
            <a href="tel:0096599886331" className="text-xl font-bold hover:underline" data-id="element-36">
              00965 99886331
            </a>
          </div>
          <div className="bg-white bg-opacity-10 p-8 rounded-lg text-center" data-id="element-37">
            <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-38">
              <MailIcon size={24} className="text-red-600" data-id="element-39" />
            </div>
            <h3 className="text-xl font-semibold mb-2" data-id="element-40">Email Us</h3>
            <p className="mb-2" data-id="element-41">We'll respond within 24 hours</p>
            <a href="mailto:george@forsatours.com" className="text-lg font-bold hover:underline" data-id="element-42">
              george@forsatours.com
            </a>
          </div>
          <div className="bg-white bg-opacity-10 p-8 rounded-lg text-center" data-id="element-43">
            <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-44">
              <MessageSquareIcon size={24} className="text-red-600" data-id="element-45" />
            </div>
            <h3 className="text-xl font-semibold mb-2" data-id="element-46">WhatsApp</h3>
            <p className="mb-2" data-id="element-47">Quick responses via WhatsApp</p>
            <a href="https://wa.me/96599886331" className="text-xl font-bold hover:underline" data-id="element-48">
              00965 99886331
            </a>
          </div>
        </div>
      </div>
    </section>;
};
export default ContactInfo;